module.exports = __webpack_public_path__ + "static/media/issues.ca65ac91.png";